import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import {
  IReferral,
  ReferralStatus,
  ReferralType,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { ReferralMenuStatusButtonsComponent } from '../referral-menu-status-buttons/referral-menu-status-buttons.component';
import { IsManagementDirective } from '@principle-theorem/ng-principle-shared';

@Component({
  selector: 'pr-referral-menu-button',
  imports: [
    ReferralMenuStatusButtonsComponent,
    MatDividerModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    IsManagementDirective,
  ],
  templateUrl: './referral-menu-button.component.html',
  styleUrl: './referral-menu-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralMenuButtonComponent {
  readonly referralType = ReferralType;

  referral = input.required<WithRef<IReferral>>();
  deleteReferral = output<WithRef<IReferral>>();
  updateStatus = output<ReferralStatus>();
  preview = output<void>();
}
